import './Loading.scss';

const Loading = () => {
    return (
        <div className="loading">Loading&#8230;</div>
    );
};

export default Loading;
